'use client';

import { createClient } from '@/lib/supabase/client';

function isSchemaError(error: any): boolean {
  if (!error) return false;
  if (error.code && typeof error.code === 'string') {
    const errorClass = error.code.substring(0, 2);
    if (errorClass === '42' || errorClass === '08') return true;
  }
  if (error.message) {
    const schemaErrorPatterns = [
      /relation.*does not exist/i,
      /column.*does not exist/i,
      /function.*does not exist/i,
    ];
    return schemaErrorPatterns.some((pattern) => pattern.test(error.message));
  }
  return false;
}

export interface ContactMessage {
  name: string;
  email: string;
  message: string;
}

export const contactService = {
  async submitMessage(messageData: ContactMessage): Promise<boolean> {
    const supabase = createClient();

    try {
      const { error } = await supabase.from('contact_messages').insert({
        name: messageData.name,
        email: messageData.email,
        message: messageData.message,
        status: 'unread',
      });

      if (error) {
        if (isSchemaError(error)) {
          console.error('Schema error:', error.message);
          throw error;
        } else {
          console.log('Contact message error:', error.message);
          return false;
        }
      }

      // Send email notification to takeazip2025@gmail.com
      try {
        await fetch('/api/send-contact-email', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            to: 'takeazip2025@gmail.com',
            name: messageData.name,
            email: messageData.email,
            message: messageData.message,
          }),
        });
      } catch (emailError) {
        console.log('Email notification failed:', emailError);
      }

      return true;
    } catch (error: any) {
      console.log('Schema-related error:', error.message);
      throw error;
    }
  },
};